import Vue from 'vue'
import 'babel-polyfill'
/* 引入 better-scroll */
import BScroll from 'better-scroll'

import loadVConsole from './utils/vconsole'

import 'vant/lib/index.css'

import App from './App'
import { createRouter } from './router'
/* vuex */
import store from './store'
/* 引入 SDK 并挂载在 Vue 上 */
import SDK from './sdk'
import env from '@/env'
import config from '@/config'
/* import rem.js for setting font-size */
import { setRem } from './utils/rem'
import { toParams } from './utils/to-params'
import { Dialog, Toast } from 'vant'
;[Dialog, Toast].forEach((comp) => {
  Vue.use(comp)
})
Toast.setDefaultOptions({
  duration: 5000
})

loadVConsole()
/* router & 历史栈 */
const router = createRouter()

for (var i in SDK) {
  Object.defineProperty(Vue.prototype, `$${i}`, { value: SDK[i] })
}

Object.defineProperty(Vue.prototype, '$env', { value: env })
Object.defineProperty(Vue.prototype, '$config', { value: config })

setRem(document, window)
const se = toParams()
const storeChannelId = localStorage.getItem('channelId')
if (!storeChannelId && se.channelId) {
  this.$store.commit('setChannel', se.channelId)
}
if (storeChannelId && !se.channelId) {
  this.$store.commit('setChannel', storeChannelId)
  localStorage.removeItem('channelId')
}
/* 返回前一个页面回到原本位置 */
Vue.mixin({
  data() {
    return {
      contentBScrollWrap: null // contentBScroll 容器
    }
  },
  methods: {
    async initBScroll() {
      return new Promise((resolve) => {
        this.$nextTick(() => {
          // ref 必须是 contentBScrollWrap
          if (this.$refs.contentBScrollWrap) {
            // 路由切换后，返回页面滚动前位置。
            // 对于 keep-alive 的页面，滚动情况也会被保存，不需担心。
            // 这里路由切换的返回滚动主要针对没有 keep-alive 的长页面，在 init 时把存在 vuex 里的 scrollY 给到 startY。
            const fullPath = this.$route.fullPath
            const scrollY =
              this.$store.state.appShell.historyPageScrollY[fullPath] || 0
            const scrollbar = {
              fade: true,
              interactive: false // 1.8.0 新增
            }
            const options = {
              click: true,
              startY: scrollY,
              scrollbar,
              preventDefaultException: { className: /(^|\s)out-of-bs(\s|$)/ }
            }
            // 需要上拉加载更多的页面
            if (this.$route.meta.needPullUp) {
              options.pullUpLoad = {
                threshold: 50
              }
            }
            // 需要下拉刷新的页面
            if (this.$route.meta.needPullDown) {
              options.pullDownRefresh = {
                threshold: 50,
                stop: 20
              }
            }
            this.$refs.contentBScrollWrap.style.height = '100vh'
            this.$refs.contentBScrollWrap.style.overflow = 'hidden'
            this.contentBScrollWrap = new BScroll(
              this.$refs.contentBScrollWrap,
              options
            )
            resolve()
          }
        })
      })
    }
  },
  // 路由切换前，保存页面滚动位置
  beforeRouteLeave(to, from, next) {
    if (this.contentBScrollWrap) {
      const scrollY = this.contentBScrollWrap.y
      this.$store.dispatch('appShell/saveScrollY', {
        path: from.fullPath,
        scrollY: scrollY
      })
    }
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  render: (h) => h(App),
  async created() {
    // 用于通告埋点插件,应用准备完毕(entry)
    this.$emit('app-launched')
  }
})
